import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const CalculatorIcon = ({
  color,
  width,
  height
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    viewBox="0 0 50 50"
    style={{
      fill: color,
      width: width,
      height: height
    }}
  >
    <path
      d="M 11 4 C 9.355469 4 8 5.355469 8 7 L 8 43 C 8 44.644531 9.355469 46 11 46 L 39 46 C 40.644531 46 42 44.644531 42 43 L 42 7 C 42 5.355469 40.644531 4 39 4 Z M 11 6 L 39 6 C 39.554688 6 40 6.445313 40 7 L 40 43 C 40 43.554688 39.554688 44 39 44 L 11 44 C 10.445313 44 10 43.554688 10 43 L 10 7 C 10 6.445313 10.445313 6 11 6 Z M 12 8 L 12 18 L 38 18 L 38 8 Z M 14 10 L 36 10 L 36 16 L 14 16 Z M 24 12 L 24 14 L 26 14 L 26 12 Z M 28 12 L 28 14 L 30 14 L 30 12 Z M 32 12 L 32 14 L 34 14 L 34 12 Z M 12.8125 22 C 12.335938 22.089844 11.992188 22.511719 12 23 L 12 41 C 12 41.550781 12.449219 42 13 42 L 37 42 C 37.550781 42 38 41.550781 38 41 L 38 23 C 38 22.449219 37.550781 22 37 22 L 13 22 C 12.96875 22 12.9375 22 12.90625 22 C 12.875 22 12.84375 22 12.8125 22 Z M 14 24 L 18 24 L 18 28 L 14 28 Z M 20 24 L 24 24 L 24 28 L 20 28 Z M 26 24 L 30 24 L 30 28 L 26 28 Z M 32 24 L 36 24 L 36 28 L 32 28 Z M 14 30 L 18 30 L 18 34 L 14 34 Z M 20 30 L 24 30 L 24 34 L 20 34 Z M 26 30 L 30 30 L 30 34 L 26 34 Z M 32 30 L 36 30 L 36 34 L 32 34 Z M 14 36 L 18 36 L 18 40 L 14 40 Z M 20 36 L 24 36 L 24 40 L 20 40 Z M 26 36 L 30 36 L 30 40 L 26 40 Z M 32 36 L 36 36 L 36 40 L 32 40 Z"
      id="surface1"
    />
  </IconSvg>
)

export default CalculatorIcon
